/**
 * Route for `bulk-campaign-actions`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { BulkCampaignActionsPage } from "../features/bulk-campaign-actions/BulkCampaignActionsPage";

export const bulkCampaignActionsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/bulk-campaign-actions",
	component: BulkCampaignActionsPage,
});

export default bulkCampaignActionsRoute;
